import React from 'react';
import './index.css';

// export const Label18 = ({ bold=false, children }) => {
//     const textStyle =  (bold) ? { fontWeight: 'bold' } : {};
//     return <label className="label18" style={textStyle}>{children}</label>;
// };

export const Label18 = ({ bold=false, disabled=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    const cssClass = disabled ? "label18 labelDisabled" : "label18";
    return <label className={cssClass} style={textStyle}>{children}</label>;
};